<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-list two-line>
        <v-subheader>Local Methods</v-subheader>
        <v-divider></v-divider>
        <div v-for="item in methods" :key="item.name">
          <v-list-tile avatar>
            <v-list-tile-content>
              <v-list-tile-title v-html="item.name"></v-list-tile-title>
              <v-list-tile-action-text v-html="item.description"></v-list-tile-action-text>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-spacer></v-spacer>
              <td class="justify-left layout px-0">
                <v-btn icon @click="addMethod(item)" :disabled="!item.active" class="mx-0" title="Add Method" v-if="allowAdding">
                  <v-icon :color="item.active ? 'cyan' : 'grey'">add_circle</v-icon>
                </v-btn>
                <router-link class="link" to=""><!--:to="item.reference" target="_blank">-->
                  <v-btn icon class="mx-0" title="References" disabled><v-icon color="cyan">book</v-icon></v-btn>
                </router-link>
              </td>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider></v-divider>
        </div>
      </v-list>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  data: () => ({
    showModal: true,
    methods: [
      {active: true, name: 'Additive Aggregation', type: 'addagg', reference: "/method-catalog/AdditiveAggregation",
        description: "Orders a given group of Options based on the given Criteria. Each option has a value for each criteria."},
      {active: true, name: 'CAT-SD', type: 'catsd', reference: "/method-catalog/CAT-SD",
        description: "CAT-SD (CATegorization by Similarity-Dissimilarity) is a multiple criteria decision aiding method for nominal classification problems."},
      {active: true, name: 'DCM-SRF', type: 'dcmsrf', reference: "/method-catalog/DCM-SRF",
        description: "The Deck Cards Method (DCM) is mainly designed for determining the weights of criteria using the revised Simos' procedure ('SRF method')."},
      {active: true, name: 'ELECTRE TRI-nC', type: 'electre', reference: "/method-catalog/ELECTRETRINC",
        description: "A multiple criteria sorting method where each category is characterized by several reference actions."},
      {active: true, name: 'Order By', type: 'orderby', reference: "/method-catalog/OrderBy",
        description: "Orders a given group of actions by a certain criterion in a specific direction."},
      {active: true, name: 'Sort', type: 'sort', reference: "/method-catalog/SortBy",
        description: "List various objects and then reorder them by their importance."}
      ]
  }),
  methods: {
    addMethod(item) {
      if(item.active)
        this.$emit('add-method', item.type, {name: item.name, type: item.type});
    }
  },
  props: {
    allowAdding: Boolean
  }
}
</script>

<style scoped>
  .link {
    text-decoration: none;
  }
</style>


// WEBPACK FOOTER //
// src/components/Catalog/Catalog.vue